// SETTINGS page — ported from the original app's SETTINGS — RENDER section, minus the
// water goal field and the whole "ИИ / API" accordion (both features removed). The
// "Синхронизация" section is adapted: the app now requires sign-in to be used at all
// (Firestore is the sole source of truth), so this shows account email + a logout button
// instead of the old optional "Войти"/local-only toggle.
import { S } from '../state.js';
import { save } from '../lib/sync.js';
import { registerPage } from '../lib/router.js';
import { logout } from '../lib/firebase.js';
import { showConfirm } from '../components/confirmDialog.js';
import { requirePassword } from '../components/passwordDialog.js';
import { resetAll } from '../lib/exportData.js';
import { dayKbzhu } from '../lib/calc.js';
import { today, fmtDate } from '../lib/dates.js';
import { APP_VERSION } from '../version.js';

let authUser = null;
export function setAuthUserForSettings(user) { authUser = user; }

export function renderSettings() {
  const st = S.settings;
  applyTheme();
  applyCustomIcon();
  document.getElementById('buildInfo').textContent = 'Версия: ' + APP_VERSION;
  document.getElementById('setStart').value = S.startWeight;
  document.getElementById('setGoal').value = S.goalWeight;
  document.getElementById('setWeightStatMode').value = st.weightStatMode || 'toGoal';
  document.getElementById('setK').value = st.goalKcal;
  document.getElementById('setP').value = st.goalP;
  document.getElementById('setF').value = st.goalF;
  document.getElementById('setC').value = st.goalC;
  document.getElementById('setUserName').value = st.userName || '';
  document.getElementById('setTgToken').value = st.tgToken || '';
  document.getElementById('setTgChat').value = st.tgChatId || '';
  document.getElementById('setNotifyEnabled').checked = st.notifyEnabled !== false;
  const cq = S.customQuotes || {};
  document.getElementById('setQuotesMorning').value = (cq.morning || []).join('; ');
  document.getElementById('setQuotesDay').value = (cq.day || []).join('; ');
  document.getElementById('setQuotesEvening').value = (cq.evening || []).join('; ');
  document.getElementById('setExportEnabled').checked = st.exportEnabled !== false;

  const emailLabel = document.getElementById('syncEmailLabel');
  if (emailLabel) emailLabel.textContent = authUser?.email || '';
}
registerPage('settings', renderSettings);

export function saveSet() {
  const st = S.settings;
  S.startWeight = parseFloat(document.getElementById('setStart').value) || S.startWeight;
  S.goalWeight = parseFloat(document.getElementById('setGoal').value) || S.goalWeight;
  st.weightStatMode = document.getElementById('setWeightStatMode').value;
  st.goalKcal = parseInt(document.getElementById('setK').value) || 2100;
  st.goalP = parseInt(document.getElementById('setP').value) || 120;
  st.goalF = parseInt(document.getElementById('setF').value) || 75;
  st.goalC = parseInt(document.getElementById('setC').value) || 230;
  st.userName = document.getElementById('setUserName').value.trim();
  st.tgToken = document.getElementById('setTgToken').value.trim();
  st.tgChatId = document.getElementById('setTgChat').value.trim();
  st.notifyEnabled = document.getElementById('setNotifyEnabled').checked;
  S.customQuotes = {
    morning: document.getElementById('setQuotesMorning').value.split(';').map(s => s.trim()).filter(Boolean),
    day: document.getElementById('setQuotesDay').value.split(';').map(s => s.trim()).filter(Boolean),
    evening: document.getElementById('setQuotesEvening').value.split(';').map(s => s.trim()).filter(Boolean),
  };
  st.exportEnabled = document.getElementById('setExportEnabled').checked;
  save(); // typed fields — debounced save is fine here (known-bugs #6)
}

export function applyTheme() {
  document.documentElement.setAttribute('data-theme', S.settings.theme === 'dark' ? 'dark' : 'light');
  const btnL = document.getElementById('themeLightBtn');
  const btnD = document.getElementById('themeDarkBtn');
  if (btnL && btnD) {
    btnL.classList.toggle('on', S.settings.theme !== 'dark');
    btnD.classList.toggle('on', S.settings.theme === 'dark');
  }
}

export function setTheme(t) {
  S.settings.theme = t;
  save(true);
  applyTheme();
}

export function uploadCustomIcon(input) {
  const file = input.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = e => {
    const img = new Image();
    img.onload = () => {
      // Favicons/app icons are always a square slot — center-crop to square here is
      // intentional (a letterboxed favicon would look broken at small sizes).
      const SIZE = 180;
      const canvas = document.createElement('canvas');
      canvas.width = SIZE; canvas.height = SIZE;
      const ctx = canvas.getContext('2d');
      const srcSize = Math.min(img.width, img.height);
      ctx.drawImage(img, (img.width - srcSize) / 2, (img.height - srcSize) / 2, srcSize, srcSize, 0, 0, SIZE, SIZE);
      S.settings.customIconUrl = canvas.toDataURL('image/png');
      save(true);
      applyCustomIcon();
      input.value = '';
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
}

export function resetCustomIcon() {
  delete S.settings.customIconUrl;
  save(true);
  applyCustomIcon();
}

let defaultIconUrl = null;
let defaultManifestHref = null;

export function applyCustomIcon() {
  if (defaultIconUrl === null) {
    const iconLink = document.querySelector('link[rel="icon"]');
    const manifestLink0 = document.querySelector('link[rel="manifest"]');
    defaultIconUrl = iconLink ? iconLink.href : '';
    defaultManifestHref = manifestLink0 ? manifestLink0.href : '';
  }

  const url = S.settings.customIconUrl;
  const preview = document.getElementById('customIconPreview');
  const resetBtn = document.getElementById('customIconResetBtn');
  if (preview) { preview.style.display = url ? '' : 'none'; if (url) preview.src = url; }
  if (resetBtn) resetBtn.style.display = url ? '' : 'none';

  if (!url) {
    document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach(el => { el.href = defaultIconUrl; });
    const manifestLinkReset = document.querySelector('link[rel="manifest"]');
    if (manifestLinkReset) manifestLinkReset.href = defaultManifestHref;
    return;
  }

  document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach(el => { el.href = url; });

  const manifest = {
    name: 'LEVEL UP', short_name: 'LEVEL UP', start_url: '.', display: 'standalone',
    background_color: '#F4F4F0', theme_color: '#1D9B5F',
    icons: [64, 192, 512].map(sizes => ({ src: url, sizes: `${sizes}x${sizes}`, type: 'image/png', purpose: 'any' })),
  };
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) manifestLink.href = 'data:application/manifest+json,' + encodeURIComponent(JSON.stringify(manifest));
}

export async function tgTest() {
  const tok = S.settings.tgToken;
  const cid = S.settings.tgChatId;
  const el = document.getElementById('tgStatus');
  if (!tok || !cid) { el.textContent = 'Заполни токен и Chat ID'; el.style.color = 'var(--amber)'; return; }
  el.textContent = 'Отправка…'; el.style.color = 'var(--text3)';
  const kbzhu = dayKbzhu(today());
  const wlog = [...S.weightLog].sort((a, b) => a.date.localeCompare(b.date));
  const lw = wlog.length ? wlog[wlog.length - 1].w : S.startWeight;
  const msg = `LEVEL UP — статус\n${fmtDate(today())}\nВес: ${lw} кг\nКалории: ${kbzhu.k} / ${S.settings.goalKcal} ккал\nБ: ${kbzhu.p} Ж: ${kbzhu.f} У: ${kbzhu.c}`;
  try {
    const r = await fetch(`https://api.telegram.org/bot${tok}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ chat_id: cid, text: msg, parse_mode: 'HTML' }),
    });
    const d = await r.json();
    if (d.ok) { el.textContent = 'Отправлено!'; el.style.color = 'var(--accent)'; }
    else { el.textContent = 'Ошибка: ' + d.description; el.style.color = 'var(--red)'; }
  } catch (e) { el.textContent = 'Ошибка сети'; el.style.color = 'var(--red)'; }
}

export function confirmResetAll() {
  requirePassword('Это удалит ВСЕ данные без возможности восстановить. Введи пароль для подтверждения:', () => {
    showConfirm('Точно удалить всё? Это необратимо.', resetAll, 'Удалить всё');
  });
}

export function doLogoutFromSettings() {
  logout();
}
